<template>
    <div class="Man-Tacografo-Principal">
        <PageTitle icon="fa fa-bus" main="Relação de troca de disco de tacógrafo"
            sub="Lançamentos" />
        <div class="Man-Tacografo-Principal">
            <b-card no-body>
                <b-tabs>                    
                    
                    <b-tab title="Lançamentos" active><JbManTacografoLancamento /></b-tab>
                    <b-tab title="Indicadores" ><JbManTacografoKpiPainel /></b-tab>
                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import JbManTacografoLancamento from '../sambaiba/JbManTacografoLancamento'
import JbManTacografoKpiPainel from '../sambaiba/JbManTacografoPainel'
export default {
    name: 'JbManTacografoOpcoes',    
    components: { PageTitle, JbManTacografoLancamento,JbManTacografoKpiPainel}
    
}
</script>

<style>

</style>







